module.exports = __webpack_public_path__ + "static/img/me4.f5540aa5.png";